import type * as zod from 'zod'
import { COMMON_WIDGET_DATA_CONSTRUCTOR, defaultInterval, IntervalSupportSchema, TIME_SELECTION, WidgetElementSchema, WidgetSchema, type BaseWidgetElementDialogProps, type PartialWidget, type PartialWidgetElement, type WidgetConstructor } from './Common'
import type { BaseWidgetDataRequest, WidgetDataResponse } from './Widgets'
import type { SetRequiredDeep } from 'type-fest'

export type TimeSelectionWidgetOptionsResponse = WidgetDataResponse & {
  type: 'TIME_SELECTION'
}

export type TimeSelectionWidgetDataRequest = BaseWidgetDataRequest & {
  type: 'TIME_SELECTION'
  widget: TimeSelectionWidget
}

export const TimeSelectionWidgetElementSchema = WidgetElementSchema.extend({
  type: TIME_SELECTION,
})
export type TimeSelectionWidgetElement = zod.infer<typeof TimeSelectionWidgetElementSchema>
export type TimeSelectionWidgetElementPartial = SetRequiredDeep<PartialWidgetElement<TimeSelectionWidgetElement>, 'type'>

export const TimeSelectionWidgetSchema = WidgetSchema.merge(IntervalSupportSchema).extend({
  type: TIME_SELECTION,
  elements: TimeSelectionWidgetElementSchema.array().max(0),
})
export type TimeSelectionWidget = zod.infer<typeof TimeSelectionWidgetSchema>
export type TimeSelectionWidgetPartial = SetRequiredDeep<PartialWidget<TimeSelectionWidget>, 'type' | 'elements' | `elements.${number}.type`>

export interface TimeSelectionWidgetElementDialogProps extends BaseWidgetElementDialogProps {
  type: 'TIME_SELECTION'
}

export const TIME_SELECTION_WIDGET_CONSTRUCTOR: WidgetConstructor<TimeSelectionWidgetPartial> = () => ({
  type: 'TIME_SELECTION',
  ...COMMON_WIDGET_DATA_CONSTRUCTOR(),
  interval: defaultInterval(),
  elements: [],
})
